import { useContext } from 'react';
import { AppContext } from '../../context/Contexte';
const BtnRestart = ({ goBack }) => {
  const { t } = useContext(AppContext);
  return (
    <>
      <div className="BackTest">
        <button
          className="button is-secondary btn__warning recommande"
          onClick={() => {
            goBack();
          }}
        >
          {t('btn_recalculate_text')}
        </button>
      </div>
    </>
  );
};

export default BtnRestart;
